module.exports = __webpack_public_path__ + "static/media/beetzmax-3.af3888ad.jpg";